
import { LanguageStrings } from '@/language/types'
import moment, { Duration } from 'moment-timezone'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Portal } from 'portal-vue'

@Component({ name: 'ExpiryTimer', components: { Portal } })
export default class extends Vue {
  t: LanguageStrings['expiryTimer']

  @Prop()
  expiresIn: Duration

  // For screen readers only
  screenReaderExpiryMinutes: number | null = null
  screenReaderExpirySeconds: number | null = null

  readonly first_threshold = 5
  readonly second_threshold = 2

  mounted() {
    this.updateScreenReaderExpiry()
  }

  updateScreenReaderExpiry() {
    this.screenReaderExpiryMinutes = this.expiresIn.minutes()
    this.screenReaderExpirySeconds = this.expiresIn.seconds()
  }

  @Watch('expiresIn')
  handleExpiresInChange() {
    const minutes = this.expiresIn.minutes()
    const seconds = this.expiresIn.seconds()

    if (seconds === 0 && (minutes === this.first_threshold || minutes === this.second_threshold)) {
      this.updateScreenReaderExpiry()
    }
  }

  get formattedTime() {
    const expiresIn = this.expiresIn
    if (expiresIn.asSeconds() > 0) {
      const format = expiresIn.asMinutes() < 10 ? 'm:ss' : 'mm:ss'
      return moment.utc(expiresIn.as('milliseconds')).format(format)
    } else {
      return null
    }
  }

  get timerClass(): '' | 'warning' | 'error' {
    const minutes = this.expiresIn.asMinutes()
    if (minutes < this.second_threshold) {
      return 'error'
    } else if (minutes < this.first_threshold) {
      return 'warning'
    }
    return ''
  }
}
